import { StaticImageData } from 'next/image'
import Image from 'next/image'
import { useEffect } from 'react'
import ReactGA from 'react-ga4'

import archidekt from '@/assets/ads/archidekt.png'
import cs from '@/assets/ads/cs.png'
import csb from '@/assets/ads/csb.png'
import duelingGuard from '@/assets/ads/duelingGuard.png'
import edhrecap from '@/assets/ads/edhrecap.png'
import edhrecast1 from '@/assets/ads/edhrecast/edhrecast1.jpg'
import edhrecast2 from '@/assets/ads/edhrecast/edhrecast2.jpg'
import edhrecast3 from '@/assets/ads/edhrecast/edhrecast3.jpg'
import edhrecPatreon from '@/assets/ads/edhrecPatreon.png'
import edhrecPatreon201 from '@/assets/ads/edhrecPatreon201.png'
import edhrecPatreon202 from '@/assets/ads/edhrecPatreon202.png'
import edhrecPatreon203 from '@/assets/ads/edhrecPatreon203.png'
import fabrec from '@/assets/ads/fabrec.png'
import gatherersTavernPoster from '@/assets/ads/gatherersTavern/16x9.jpg'
import gatherersTavernBanner from '@/assets/ads/gatherersTavern/728x90.jpg'
import gatherersTavernPosterAvatar from '@/assets/ads/gatherersTavern/avatar16x9.png'
import gatherersTavernBannerAvatar from '@/assets/ads/gatherersTavern/avatar728x90.png'
import spellifyDark1 from '@/assets/ads/spellifyDark1.png'
import spellifyDark2 from '@/assets/ads/spellifyDark2.png'
import spellifyLight1 from '@/assets/ads/spellifyLight1.png'
import spellifyLight2 from '@/assets/ads/spellifyLight2.png'
import OutboundLink from '@/components/OutboundLink/OutboundLink'
import { useAppSelector } from '@/store/hooks'
import useDirectories from '@/utils/useDirectories'

import styles from './Ad.module.scss'

type AdConfigItem = {
  alt: string
  disableUtm?: boolean
  src: StaticImageData | { lg: StaticImageData; sm: StaticImageData }
  url: string | { lg: string; sm: string }
  urlConfigs?: { src: StaticImageData; subpage: string; url: string }[]
}

const config: { [key: string]: AdConfigItem } = {
  archidekt: { alt: 'Archidekt', src: archidekt, url: 'https://archidekt.com/landing' },
  cs: { alt: 'Cardsphere', src: cs, url: 'cardsphere.com' },
  csb: { alt: 'Commander Spellbook', src: csb, url: 'commanderspellbook.com' },
  duelingGuard: {
    alt: 'Dueling Guard',
    src: duelingGuard,
    url: 'https://duelingguard.com/?utm_content=edhrec_banner',
  },
  edhrecap: { alt: 'EDHRecap', src: edhrecap, url: 'edhrec.com/newsletter' },
  edhrecast1: {
    alt: 'EDHRECast',
    src: edhrecast1,
    url: 'https://www.youtube.com/edhrecast?utm_campaign=bannertestedhrecast1',
  },
  edhrecast2: {
    alt: 'EDHRECast',
    src: edhrecast2,
    url: 'https://www.youtube.com/edhrecast?utm_campaign=bannertestedhrecast2',
  },
  edhrecast3: {
    alt: 'EDHRECast',
    src: edhrecast3,
    url: 'https://www.youtube.com/edhrecast?utm_campaign=bannertestedhrecast3',
  },
  edhrecPatreon: { alt: 'EDHREC Patreon', src: edhrecPatreon, url: 'patreon.com/edhrec' },
  edhrecPatreon201: { alt: 'EDHREC Patreon', src: edhrecPatreon201, url: 'patreon.com/edhrec' },
  edhrecPatreon202: { alt: 'EDHREC Patreon', src: edhrecPatreon202, url: 'patreon.com/edhrec' },
  edhrecPatreon203: { alt: 'EDHREC Patreon', src: edhrecPatreon203, url: 'patreon.com/edhrec' },
  fabrec: { alt: 'FABREC', src: fabrec, url: 'fabrec.gg' },
  /* heavyPlay: {
    alt: 'Heavy Play',
    src: heavyPlay5Color,
    url: 'heavyplay.com',
    urlConfigs: [
      { src: heavyPlayWhite, subpage: 'w', url: 'https://heavyplay.com/collections/white' },
      { src: heavyPlayBlue, subpage: 'u', url: 'https://heavyplay.com/collections/blue' },
      { src: heavyPlayBlack, subpage: 'b', url: 'https://heavyplay.com/collections/black' },
      { src: heavyPlayRed, subpage: 'r', url: 'https://heavyplay.com/collections/red' },
      { src: heavyPlayGreen, subpage: 'g', url: 'https://heavyplay.com/collections/green' },
      { src: heavyPlayColorless, subpage: 'colorless', url: 'https://heavyplay.com/collections/colorless' },
      { src: heavyPlayAzorius, subpage: 'wu', url: 'https://heavyplay.com/collections/azorius' },
      { src: heavyPlayDimir, subpage: 'ub', url: 'https://heavyplay.com/collections/dimir' },
      { src: heavyPlayRakdos, subpage: 'br', url: 'https://heavyplay.com/collections/rakdos' },
      { src: heavyPlayGruul, subpage: 'rg', url: 'https://heavyplay.com/collections/gruul' },
      { src: heavyPlaySelesnya, subpage: 'gw', url: 'https://heavyplay.com/collections/selesnya' },
      { src: heavyPlayOrzhov, subpage: 'wb', url: 'https://heavyplay.com/collections/orzhov' },
      { src: heavyPlayIzzet, subpage: 'ur', url: 'https://heavyplay.com/collections/izzet' },
      { src: heavyPlayGolgari, subpage: 'bg', url: 'https://heavyplay.com/collections/golgari' },
      { src: heavyPlayBoros, subpage: 'rw', url: 'https://heavyplay.com/collections/boros' },
      { src: heavyPlaySimic, subpage: 'gu', url: 'https://heavyplay.com/collections/simic' },
      { src: heavyPlayEsper, subpage: 'wub', url: 'https://heavyplay.com/collections/esper' },
      { src: heavyPlayGrixis, subpage: 'ubr', url: 'https://heavyplay.com/collections/grixis' },
      { src: heavyPlayJund, subpage: 'brg', url: 'https://heavyplay.com/collections/jund' },
      { src: heavyPlayNaya, subpage: 'rgw', url: 'https://heavyplay.com/collections/naya' },
      { src: heavyPlayBant, subpage: 'gwu', url: 'https://heavyplay.com/collections/bant' },
      { src: heavyPlayAbzan, subpage: 'wbg', url: 'https://heavyplay.com/collections/abzan' },
      { src: heavyPlayJeskai, subpage: 'urw', url: 'https://heavyplay.com/collections/jeskai' },
      { src: heavyPlaySultai, subpage: 'bgu', url: 'https://heavyplay.com/collections/sultai' },
      { src: heavyPlayMardu, subpage: 'rwb', url: 'https://heavyplay.com/collections/mardu' },
      { src: heavyPlayTemur, subpage: 'gur', url: 'https://heavyplay.com/collections/temur' },
      { src: heavyPlay5Color, subpage: 'wubrg', url: 'https://heavyplay.com/collections/wubrg' },
    ],
  }, */
  gatherersTavernBannerAppa: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernBannerAvatar,
    url: 'https://www.gathererstavern.com/products/appa-arty-box?variant=51428309303575',
  },
  gatherersTavernBannerBetor: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernBanner,
    url: 'https://www.gathererstavern.com/products/tarkir-dragons-keychains?variant=50469558223127',
  },
  gatherersTavernBannerMomo: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernBannerAvatar,
    url: 'https://www.gathererstavern.com/products/momo-arty-box?variant=51428328505623',
  },
  gatherersTavernBannerNeriv: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernBanner,
    url: 'https://www.gathererstavern.com/products/tarkir-dragons-keychains?variant=50469558255895',
  },
  gatherersTavernBannerShiko: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernBanner,
    url: 'https://www.gathererstavern.com/products/tarkir-dragons-keychains?variant=50469558288663',
  },
  gatherersTavernBannerTeval: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernBanner,
    url: 'https://www.gathererstavern.com/products/tarkir-dragons-keychains?variant=50469558321431',
  },
  gatherersTavernBannerUreni: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernBanner,
    url: 'https://www.gathererstavern.com/products/tarkir-dragons-keychains?variant=50469558354199',
  },
  gatherersTavernPosterAppa: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernPosterAvatar,
    url: 'https://www.gathererstavern.com/products/appa-arty-box?variant=51428309303575',
  },
  gatherersTavernPosterBetor: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernPoster,
    url: 'https://www.gathererstavern.com/products/tarkir-dragonstorm-domaru-boxes?variant=50297395282199',
  },
  gatherersTavernPosterMomo: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernPosterAvatar,
    url: 'https://www.gathererstavern.com/products/momo-arty-box?variant=51428328505623',
  },
  gatherersTavernPosterNeriv: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernPoster,
    url: 'https://www.gathererstavern.com/products/tarkir-dragonstorm-domaru-boxes?variant=50297395314967',
  },
  gatherersTavernPosterShiko: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernPoster,
    url: 'https://www.gathererstavern.com/products/tarkir-dragonstorm-domaru-boxes?variant=50297395347735',
  },
  gatherersTavernPosterTeval: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernPoster,
    url: 'https://www.gathererstavern.com/products/tarkir-dragonstorm-domaru-boxes?variant=50297395380503',
  },
  gatherersTavernPosterUreni: {
    alt: "Gatherer's Tavern",
    src: gatherersTavernPoster,
    url: 'https://www.gathererstavern.com/products/tarkir-dragonstorm-domaru-boxes?variant=50297395413271',
  },
  placeholder: {
    alt: 'An entry with lg and sm must exist to satisfy TypeScript',
    src: { lg: archidekt, sm: archidekt },
    url: { lg: '', sm: '' },
  },
  spellifyDark1: {
    alt: 'Spellify',
    src: spellifyDark1,
    url: 'https://edhrec.com/games/spellify?utm_campaign=dark1',
  },
  spellifyDark2: {
    alt: 'Spellify',
    src: spellifyDark2,
    url: 'https://edhrec.com/games/spellify?utm_campaign=dark2',
  },
  spellifyLight1: {
    alt: 'Spellify',
    src: spellifyLight1,
    url: 'https://edhrec.com/games/spellify?utm_campaign=light1',
  },
  spellifyLight2: {
    alt: 'Spellify',
    src: spellifyLight2,
    url: 'https://edhrec.com/games/spellify?utm_campaign=light2',
  },
}

type Props = {
  id: keyof typeof config
}

const Ad = ({ id }: Props) => {
  const displayName = useAppSelector((state) => state.user.displayName)
  const { subpage } = useDirectories()

  useEffect(() => {
    ReactGA.event({
      action: 'Load',
      category: 'Ad',
      label: id as string,
      nonInteraction: true,
    })
    if (displayName) {
      ReactGA.event({
        action: 'Load-LoggedIn',
        category: 'Ad',
        label: id as string,
        nonInteraction: true,
      })
    }
  }, [id])

  if (!Object.keys(config).includes(id as string)) {
    return null
  }

  const { alt, disableUtm, src, url, urlConfigs } = config[id]

  if (urlConfigs && subpage) {
    const subpageAd = urlConfigs.find((urlConfig) => urlConfig.subpage === subpage)
    if (subpageAd) {
      return (
        <OutboundLink url={subpageAd.url} utm_medium='leaderboard'>
          <img alt={alt} className={styles.ad} src={('src' in subpageAd.src && subpageAd.src.src) || ''} />
        </OutboundLink>
      )
    }
  }

  if (typeof url === 'string') {
    return (
      <OutboundLink disableUtm={disableUtm} url={url} utm_medium='leaderboard'>
        <img alt={alt} className={styles.ad} src={('src' in src && src.src) || ''} />
      </OutboundLink>
    )
  } else {
    return (
      <>
        <OutboundLink className='d-block d-sm-none' url={url.sm} utm_medium='leaderboard'>
          <Image alt={alt} className={styles.ad} src={('sm' in src && src.sm.src) || ''} />
        </OutboundLink>
        <OutboundLink className='d-none d-sm-block' url={url.lg} utm_medium='leaderboard'>
          <Image alt={alt} className={styles.ad} src={('lg' in src && src.lg.src) || ''} />
        </OutboundLink>
      </>
    )
  }
}

export { config }
export default Ad
